/**
 * Context for CollectionInteraction Consumer and Provider
 */

import { createContext } from 'preact';

/**
 * This context (with value 'embedded') should be created by component that has a drop down and the drop down
 * contains a Collection component that uses grid role (ListView and Table).
 * The behavior of the Collection component will alter when it is inside of a drop down.  Specifically, pressing
 * enter will update selections, pressing spacebar will fire action events, and the current row/item will be highlighted.
 */
export const CollectionInteractionContext = createContext<'default' | 'embedded' | undefined>(
  'default'
);
